module.exports = __webpack_public_path__ + "static/media/canais-8.91fce7a2.jpg";